import ReportStockCard from '@/models/ReportStockCard/ReportStockCard';

export default class ReportStockCardFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.filterPart = '';
		this.filterRack = '';
		this.filterCustomer = '';
		this.filterArea = '';
		this.filterControlCard = '';
		this.filterUom = '';
		this.filterQcStatus = '';
		this.filterTransactionDateFrom = '';
		this.filterTransactionDateTo = '';
		this.tempId = '';
		this.areaName = '';
		this.rackName = '';
		this.customerName = '';
		this.controlCardNumber = '';
		this.partNumber = '';
		this.partName = '';
		this.qtyCase = '';
		this.uomName = '';
		this.createdDateFrom = '';
		this.createdDateTo = '';
		this.qcStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			filterPart : '0',
			filterRack : '0',
			filterCustomer : '0',
			filterArea : '0',
			filterControlCard : '0',
			filterUom : '0',
			filterQcStatus : '0',
			filterTransactionDateFrom : '0',
			filterTransactionDateTo : '0',
			tempId : '0',
			areaName : '0',
			rackName : '0',
			customerName : '0',
			controlCardNumber : '0',
			partNumber : '0',
			partName : '0',
			qtyCase : '0',
			uomName : '0',
			createdDateFrom : '0',
			createdDateTo : '0',
			qcStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}